import { cUtil }                       from "../../functions/util";
import { cAdminDeliveryItemsCustomer } from "./admin-delivery-items-customer";

export class cAdminDeliveryItems {

  parent        = document.querySelector('.c-delivery-items')        as HTMLElement;
  script        = document.querySelector('.c-delivery-items script') as HTMLScriptElement;

  div_select    = document.createElement('div');
  div_from      = document.createElement('div');
  label_from    = document.createElement('label');
  input_from    = document.createElement('input');
  div_to        = document.createElement('div');
  label_to      = document.createElement('label');
  input_to      = document.createElement('input');
  div_checks    = document.createElement('div');
  div_private   = document.createElement('div');
  input_private = document.createElement('input');
  label_private = document.createElement('label');
  div_open      = document.createElement('div');
  input_open    = document.createElement('input');
  label_open    = document.createElement('label');
  div_upload    = document.createElement('div');
  input_files   = document.createElement('input');
  button_upload = document.createElement('button');
  p_error       = document.createElement('p');
  div_problems  = document.createElement('div');
  div_legend    = document.createElement('div');

  dialog          = document.createElement('dialog');
  h2_dialog       = document.createElement('h2');
  div_dialogBody  = document.createElement('div');
  div_dialogFoot  = document.createElement('div');
  button_confirm  = document.createElement('button');
  button_cancel   = document.createElement('button');

  pendingFiles : string[] = [];

  data      : DeliveryPeriodData;
  customers : cAdminDeliveryItemsCustomer[] = [];

  constructor() {

    this.data = JSON.parse(this.script.innerText) as DeliveryPeriodData;

    // ---- Structure ----
    this.parent.append(this.div_select);
      this.div_select.append(this.div_from);
        this.div_from.append(this.label_from);
        this.div_from.append(this.input_from);
      this.div_select.append(this.div_to);
        this.div_to.append(this.label_to);
        this.div_to.append(this.input_to);
      this.div_select.append(this.div_checks);
        this.div_checks.append(this.div_private);
          this.div_private.append(this.input_private);
          this.div_private.append(this.label_private);
        this.div_checks.append(this.div_open);
          this.div_open.append(this.input_open);
          this.div_open.append(this.label_open);
      this.div_select.append(this.div_upload);
        this.div_upload.append(this.input_files);
        this.div_upload.append(this.button_upload);
    this.parent.append(this.p_error);
    this.parent.append(this.div_problems);
    this.parent.append(this.div_legend);
    this.parent.append(this.dialog);
      this.dialog.append(this.h2_dialog);
      this.dialog.append(this.div_dialogBody);
      this.dialog.append(this.div_dialogFoot);
        this.div_dialogFoot.append(this.button_cancel);
        this.div_dialogFoot.append(this.button_confirm);

    // ---- Init ----
    this.div_select .classList.add('c-selection');
    this.div_checks .classList.add('c-checks');
    this.div_private.classList.add('c-check');
    this.div_open   .classList.add('c-check');
    this.div_upload .classList.add('c-upload');
    this.p_error    .classList.add('c-period-error');
    this.div_legend .classList.add('c-legend');

    this.label_from   .innerText = 'Liefertag von';
    this.label_to     .innerText = 'Liefertag bis';
    this.label_private.innerText = 'Nur Privatkunden anzeigen';
    this.label_open   .innerText = 'Nur offene Bestellungen anzeigen';

    this.dateInput(this.input_from, this.label_from, 'c-delivery-from', this.data.from);
    this.dateInput(this.input_to  , this.label_to  , 'c-delivery-to'  , this.data.to);

    this.checkbox(this.input_private, this.label_private, 'c-delivery-private', this.data.onlyPrivate);
    this.checkbox(this.input_open   , this.label_open   , 'c-delivery-open'   , this.data.onlyOpen);

    this.input_files.type     = 'file';
    this.input_files.multiple = true;
    this.input_files.accept   = '.csv';
    this.input_files.setAttribute('aria-label', 'Lieferschein-Exporte');

    this.button_upload.type      = 'button';
    this.button_upload.innerText = 'Lieferschein-Exporte hochladen';
    this.button_upload.disabled  = true;
    this.button_upload.classList.add('button');

    this.dialog.classList.add('c-dialog');
    this.button_cancel.type       = 'button';
    this.button_cancel.innerText  = 'Abbrechen';
    this.button_cancel.classList.add('button');
    this.button_confirm.type      = 'button';
    this.button_confirm.innerText = 'Importieren';
    this.button_confirm.classList.add('button', 'button-primary');

    this.p_error.innerText = this.data.error;
    if (this.data.error === '') this.p_error.style.display = 'none';

    this.problems();
    this.legend();

    for (const customer of this.data.customers) {
      this.customers.push(new cAdminDeliveryItemsCustomer(this.parent, customer, this));
    }
    this.fitOrderedColumn();

    // ---- Events ----
    for (const input of [this.input_from, this.input_to, this.input_private, this.input_open]) {
      input.addEventListener('change', () => this.reload());
    }

    this.input_files.addEventListener('change', () => {
      this.button_upload.disabled = (this.input_files.files?.length ?? 0) === 0;
    });

    this.button_upload.addEventListener('click', () => void this.upload());
    this.button_confirm.addEventListener('click', () => void this.confirm());
    this.button_cancel.addEventListener('click', () => {
      // Declining leaves the whole upload unimported, also the files without a conflict.
      this.dialog.close();
      this.pendingFiles = [];
      this.toast('Der Import wurde abgebrochen, es wurde nichts geschrieben.', false);
    });
  }

  async upload(): Promise<void> {
    const files = this.input_files.files;
    if (files === null || files.length === 0) return;

    const formData = new FormData();
    formData.append('_ajax_nonce', this.data.nonce);
    formData.append('action'     , 'c_delivery_note_upload');
    for (const file of Array.from(files)) formData.append('files[]', file);

    this.button_upload.disabled = true;
    const result = await this.postImport(formData);
    this.button_upload.disabled = false;

    this.handleImport(result);
  }

  async confirm(): Promise<void> {
    const formData = new FormData();
    formData.append('_ajax_nonce', this.data.nonce);
    formData.append('action'     , 'c_delivery_note_upload_confirm');
    formData.append('files'      , JSON.stringify(this.pendingFiles));

    this.button_confirm.disabled = true;
    const result = await this.postImport(formData);
    this.button_confirm.disabled = false;

    this.dialog.close();
    this.handleImport(result);
  }

  handleImport(result: DeliveryImportResult): void {
    for (const error of result.errors) this.toast(error, true);

    if (result.needsConfirm) {
      this.pendingFiles = result.files;
      this.showConflicts(result.conflicts);
      return;
    }
    if (!result.ok) {
      this.toast(result.message, true);
      return;
    }

    // The page is rendered again from the database. Filling the inputs here would fire no blur
    // event, so the per row auto save would never store the imported values.
    this.toast(result.message, false);
    window.location.reload();
  }

  showConflicts(conflicts: DeliveryImportConflicts): void {
    this.div_dialogBody.innerHTML = '';

    // Lines of a captured order alone overwrite nothing, the dialog only reports them.
    const overwrites = conflicts.noteNumbers.length > 0 || conflicts.overwrites.length > 0;
    this.h2_dialog.innerText = overwrites ? 'Bestehende Daten überschreiben?' : 'Positionen werden übersprungen';

    if (conflicts.noteNumbers.length > 0) {
      const items = conflicts.noteNumbers.map(
        (note) => `Lieferschein ${note.delivery_note_no}: ${note.rows} Positionen werden gelöscht und neu importiert.`
      );
      this.conflictList('Erneuter Import von Lieferscheinen', items);
    }

    if (conflicts.overwrites.length > 0) {
      const items = conflicts.overwrites.map((over) => {
        const date = over.delivery_date === '' ? '' : ` · ${cUtil.isoToCh(over.delivery_date)}`;
        const note = over.delivery_note_no === '' ? 'von Hand erfasst' : `Lieferschein ${over.delivery_note_no}`;
        return `${over.customer_id} · ${over.SKU} ${over.name}${date} (${note})`;
      });
      this.conflictList('Bestehende Werte werden überschrieben', items);
    }

    if (conflicts.skipped.length > 0) {
      const items = conflicts.skipped.map((skip) => {
        const date = skip.delivery_date === '' ? '' : ` · ${cUtil.isoToCh(skip.delivery_date)}`;
        const note = skip.delivery_note_no === '' ? '' : ` (Lieferschein ${skip.delivery_note_no})`;
        return `#${skip.order_id} · ${skip.SKU} ${skip.name}${date}${note}`;
      });
      this.conflictList('Nicht importiert, die Bestellung ist bereits eingezogen', items);
    }

    this.dialog.showModal();
  }

  conflictList(title: string, items: string[]): void {
    const h3 = document.createElement('h3');
    const ul = document.createElement('ul');
    h3.innerText = title;
    for (const item of items) {
      const li = document.createElement('li');
      li.innerText = item;
      ul.append(li);
    }
    this.div_dialogBody.append(h3);
    this.div_dialogBody.append(ul);
  }

  async postImport(formData: FormData): Promise<DeliveryImportResult> {
    try {
      const response = await fetch('/wp-admin/admin-ajax.php', {method: 'POST', body: formData});
      return await response.json() as DeliveryImportResult;
    }
    catch (e) {
      return {
        ok: false, needsConfirm: false, message: 'Die Verbindung zum Server ist fehlgeschlagen.',
        imported: 0, matched: 0, unmatched: 0, deleted: 0, skipped: 0, files: [], errors: [],
        conflicts: {noteNumbers: [], overwrites: [], skipped: []},
      };
    }
  }

  dateInput(input: HTMLInputElement, label: HTMLLabelElement, id: string, value: string): void {
    input.type  = 'date';
    input.value = value;
    input.id    = id;
    label.setAttribute('for', id);
  }

  checkbox(input: HTMLInputElement, label: HTMLLabelElement, id: string, checked: boolean): void {
    input.type    = 'checkbox';
    input.checked = checked;
    input.id      = id;
    label.setAttribute('for', id);
  }

  // Above the list, so that an order with a capture problem is not missed on a long page. Each
  // number jumps to its order, which carries the problem and the Erledigt button.
  // "notice inline" is the wp-admin notice, inline keeps wp-admin from moving it below the h1.
  problems(): void {
    const orderIds = this.data.problemOrders;
    if (orderIds.length === 0) {
      this.div_problems.style.display = 'none';
      return;
    }

    this.div_problems.classList.add('notice', 'notice-error', 'inline', 'c-problems');

    const p_text = document.createElement('p');
    p_text.append(orderIds.length === 1
      ? 'Im gewählten Zeitraum gibt es eine Bestellung mit einem Problem beim Einzug: '
      : `Im gewählten Zeitraum gibt es ${orderIds.length} Bestellungen mit einem Problem beim Einzug: `);

    orderIds.forEach((orderId, i) => {
      const a_order = document.createElement('a');
      a_order.href      = `#c-order-${orderId}`;
      a_order.innerText = `#${orderId}`;
      if (i > 0) p_text.append(', ');
      p_text.append(a_order);
    });

    this.div_problems.append(p_text);
  }

  // Bestellt as wide as its widest cell on the page, heading included. The same width for every
  // order, so that their tables still line up below each other. Measured again once the fonts are
  // in, since they change the width of the text.
  fitOrderedColumn(): void {
    const measure = (): void => {
      let widest = 0;
      for (const elm of this.parent.querySelectorAll<HTMLElement>('.c-ordered-cell > *')) {
        widest = Math.max(widest, elm.getBoundingClientRect().width);
      }
      const th = this.parent.querySelector('th:nth-child(4)');
      if (th !== null) {
        const range = document.createRange();
        range.selectNodeContents(th);
        widest = Math.max(widest, range.getBoundingClientRect().width);
      }
      if (widest === 0) return;

      // td and th have 8px padding on either side, box-sizing is border-box.
      this.parent.style.setProperty('--c-ordered-width', `${Math.ceil(widest) + 16}px`);
    };

    measure();
    document.fonts.ready.then(measure).catch(() => {});
  }

  legend(): void {
    const entries: [string, string][] = [
      ['c-icon-error', 'Liefermenge fehlt'],
      ['c-icon-info' , 'Abweichung zur Bestellung'],
      ['c-icon-muted', 'Keine WooCommerce-Verknüpfung'],
      ['c-icon-saved', 'Gerade gespeichert'],
    ];
    const signs: Record<string, string> = {
      'c-icon-error': '!',
      'c-icon-info' : 'i',
      'c-icon-muted': '–',
      'c-icon-saved': '✓',
    };

    for (const [css, text] of entries) {
      const span_entry = document.createElement('span');
      const span_icon  = document.createElement('span');
      const span_text  = document.createElement('span');
      span_icon.classList.add('c-icon', css);
      span_icon.innerText = signs[css] ?? '';
      span_text.innerText = text;
      span_entry.append(span_icon);
      span_entry.append(span_text);
      this.div_legend.append(span_entry);
    }
  }

  reload(): void {
    if (this.input_from.value === '' || this.input_to.value === '') return;
    const urlParams = new URLSearchParams();
    urlParams.set('page'   , 'lieferungen');
    urlParams.set('from'   , this.input_from.value);
    urlParams.set('to'     , this.input_to.value);
    urlParams.set('private', this.input_private.checked ? '1' : '0');
    urlParams.set('open'   , this.input_open.checked    ? '1' : '0');
    window.location.href = '/wp-admin/admin.php?' + urlParams.toString();
  }

  // A capture and a closed problem leave the page as it is. Their message says how to see the new
  // state of the order.
  reloadHint(message: string): string {
    const sentence = /[.!?]$/.test(message) ? message : `${message}.`;
    return `${sentence} Für den aktuellen Stand die Seite neu laden.`;
  }

  toast(message: string, isError: boolean): void {
    window.Toastify({
      text      : message,
      className : isError ? 'c-error' : 'c-success',
      offset    : {x: 0, y: '20px'},
      close     : true,
    }).showToast();
  }

  // order_item_id is not an input, it only tells the server which woocommerce line item a not yet
  // stored row belongs to. For a stored row the server ignores it.
  async fetchLine(line: DeliveryItemLine, action: string): Promise<DeliverySaveResult> {
    const payload = {
      id                : line.id,
      order_item_id     : line.order_item_id,
      new_price         : line.new_price,
      new_delivery_date : line.new_delivery_date,
      new_total_amount  : line.new_total_amount,
      delivery_note_no  : line.delivery_note_no,
    };

    const formData = new FormData();
    formData.append('_ajax_nonce', this.data.nonce);
    formData.append('action'     , action);
    formData.append('data'       , JSON.stringify(payload));

    return await this.post(formData);
  }

  // Only a delivery note line without a counterpart, the server checks it.
  async fetchDelete(id: number): Promise<DeliverySaveResult> {
    const formData = new FormData();
    formData.append('_ajax_nonce', this.data.nonce);
    formData.append('action'     , 'c_delivery_item_delete');
    formData.append('data'       , JSON.stringify({id}));

    return await this.post(formData);
  }

  async fetchFee(fee: DeliveryExtraLine): Promise<DeliverySaveResult> {
    const payload = {
      order_item_id : fee.order_item_id,
      delivered     : fee.delivered,
    };

    const formData = new FormData();
    formData.append('_ajax_nonce', this.data.nonce);
    formData.append('action'     , 'c_delivery_fee_save');
    formData.append('data'       , JSON.stringify(payload));

    return await this.post(formData);
  }

  // The Liefersumme as the page shows it. The server calculates it again and refuses the capture
  // if the two differ, so that nothing is captured the person has not seen.
  async fetchCapture(orderId: number, amount: string): Promise<DeliverySaveResult> {
    const payload = {
      order_id : orderId,
      amount   : amount,
    };

    const formData = new FormData();
    formData.append('_ajax_nonce', this.data.nonce);
    formData.append('action'     , 'c_delivery_capture');
    formData.append('data'       , JSON.stringify(payload));

    return await this.post(formData);
  }

  // The job tells the server which problem was seen, a newer one of the same order stays open.
  async fetchProblemAck(orderId: number, jobId: number): Promise<DeliverySaveResult> {
    const payload = {
      order_id : orderId,
      job_id   : jobId,
    };

    const formData = new FormData();
    formData.append('_ajax_nonce', this.data.nonce);
    formData.append('action'     , 'c_delivery_problem_ack');
    formData.append('data'       , JSON.stringify(payload));

    return await this.post(formData);
  }

  // A coupon row is a tax rate of the order, so the order and the rate identify it.
  async fetchCoupon(orderId: number, coupon: DeliveryExtraLine): Promise<DeliverySaveResult> {
    const payload = {
      order_id  : orderId,
      tax_rate  : coupon.tax_rate,
      delivered : coupon.delivered,
    };

    const formData = new FormData();
    formData.append('_ajax_nonce', this.data.nonce);
    formData.append('action'     , 'c_delivery_coupon_save');
    formData.append('data'       , JSON.stringify(payload));

    return await this.post(formData);
  }

  async post(formData: FormData): Promise<DeliverySaveResult> {
    try {
      const response = await fetch('/wp-admin/admin-ajax.php', {
        method : 'POST',
        body   : formData,
      });
      return await response.json() as DeliverySaveResult;
    }
    catch (e) {
      return {ok: false, message: 'Die Verbindung zum Server ist fehlgeschlagen.', field: '', id: 0};
    }
  }
}
